import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22e5935e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "top-box" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "left-title" }
const _hoisted_6 = { class: "left-serial-number" }
const _hoisted_7 = { class: "left-middle-text fix-margin-t-16" }
const _hoisted_8 = {
  key: 0,
  class: "left-middle-text"
}

import AppHeader from '@/components/Header.vue'
import { onMounted, ref, Ref, withDefaults } from 'vue'
import { lastXcareItem } from '@/types/three-liability-insurance'
import { getlastXcare } from '@/apis/three-liability-insurance'
import { Toast } from 'vant'
import { AxiosError } from 'axios'
import { getStatusBgColor } from './common'
import { serviceType } from '@/types/three-liability-insurance'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-list',
  props: {
    displayMode: { default: 'Portrait' }
  },
  setup(__props: any) {

const props = __props as { displayMode: string };

const router = useRouter()
const route = useRoute()
const sn = route.query.sn as string
const xcareList: Ref<
  Array<
    lastXcareItem & {
      bgColor: string
      hasInsurance?: boolean
    }
  >
> = ref([])



async function extremeServiceData() {
  try {
    Toast.loading({
      message: '加载中...',
      duration: 0,
    })
    let data = await getlastXcare({ serial_number: sn as string })
    if (!data || data.length === 0) {
      data = [
        {
          end_at: '',
          start_at: '',
          status: '',
          status_text: '无服务',
          type: 1,
          policy_no: '',
          service_type: 0, // 自定义为0  后续点击不会处理
          type_name: '无人机意外机损保险',
        },
      ]
    }
    xcareList.value = data.map((item) => ({
      ...item,
      hasInsurance: item.status_text !== '无服务' && item.status_text !== '待支付',
      bgColor: getStatusBgColor(item.status_text),
    }))
    Toast.clear()
  } catch (e) {
    console.log(e)
    Toast.clear()
    Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
  }
}
function toDetailHandle(item: lastXcareItem) {
  if (item.service_type === 2) {
    const query: Record<string, string> = {
      type: 'appInsuranceDetail',
    }
    if (item.status === 1) {
      query.eq_sn = sn
    } else {
      query.policy_no = item.policy_no
    }
    router.push({
      name: 'insurance-jijia-insurance-detail',
      query,
    })
  }
}
onMounted(async () => {
  extremeServiceData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "无人机意外机损保险" }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xcareList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["content", props.displayMode === 'Landscape' ? 'landscape-width' : '']),
        key: index,
        onClick: ($event: any) => (toDetailHandle(item))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.type_name), 1),
              _createElementVNode("span", _hoisted_6, "设备序列号：" + _toDisplayString(_unref(sn)), 1),
              (item.hasInsurance)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_7, "生效时间：" + _toDisplayString(item.start_at), 1),
                    (item.status !== 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "到期时间：" + _toDisplayString(item.end_at), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "tag",
              style: _normalizeStyle({ background: item.bgColor })
            }, _toDisplayString(item.status_text), 5)
          ])
        ])
      ], 10, _hoisted_1))
    }), 128))
  ], 64))
}
}

})